import { PermissionEnum } from '@/enums/PermissionEnum';
import { useSessionStore } from '@/stores/components/sessionStore'

export function checkPermissions(permissions: PermissionEnum[] | string[] = [], permissions_operator: 'AND' | 'OR' = 'AND', options: {like?: boolean} = {}) {

  const sessionStore = useSessionStore()
  const storedPermissions = sessionStore?.userData?.permissoes ?? []
  const AND = 'AND'
  const OR = 'OR'

  if (!Array.isArray(storedPermissions)) {
    return false
  }

  try {

    options.like = options.like || false;

    let permited = false

    if (permissions_operator === AND) {

      permited = true
      permissions.forEach((perm: PermissionEnum | string) => {

        if(options.like) {
          if (!storedPermissions.some((permissao) => permissao.includes(perm))) {
            permited = false
          }
        }

        if (!storedPermissions.includes(perm)) {
          permited = false
        }

      })

      if (permited) {
        return true
      }

      return false

    }else if (permissions_operator === OR) {
      
      permited = false

      permissions.forEach((perm: PermissionEnum | string) => {

        if(options.like) {
          if (storedPermissions.some((permissao) => permissao.includes(perm))) {
            permited = true
          }
        }

        if (storedPermissions.includes(perm)) {
          permited = true
        }

      })

      if (permited) {
        return true
      }

      return false

    }

    return false

  } catch (error) {

    console.error(error)
    return false

  }

}
